/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ContactList
 */
export interface ContactList {
  /**
   *
   * @type {string}
   * @memberof ContactList
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof ContactList
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof ContactList
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof ContactList
   */
  updatedAt?: string
  /**
   *
   * @type {boolean}
   * @memberof ContactList
   */
  isPin?: boolean
  /**
   *
   * @type {number}
   * @memberof ContactList
   */
  countsOfListItem?: number
}

export function ContactListFromJSON(json: any): ContactList {
  return ContactListFromJSONTyped(json, false)
}

export function ContactListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactList {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    isPin: !exists(json, 'is_pin') ? undefined : json['is_pin'],
    countsOfListItem: !exists(json, 'counts_of_list_item') ? undefined : json['counts_of_list_item']
  }
}

export function ContactListToJSON(value?: ContactList | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    is_pin: value.isPin,
    counts_of_list_item: value.countsOfListItem
  }
}
